import React from 'react';
import PropTypes from 'prop-types';

function ProxyImage({ src, ...props }) {

	const url = new URL(process.env.REACT_APP_IMAGE_EMBEDDING_URL);

	url.pathname = 'proxy'
	url.searchParams.set('url', src);
	// eslint-disable-next-line jsx-a11y/alt-text
	return <img src={url} referrerPolicy="no-referrer" {...props} />;
}

ProxyImage.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
};

export default ProxyImage;
